"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var RealImpactValueConverter_1 = require("../impact/conversions/RealImpactValueConverter");

var RealImpactValueConverterImpl_1 = require("../impact/conversions/RealImpactValueConverterImpl");

var PriceStatsConverter_1 = require("../price-list/conversions/PriceStatsConverter");

var PriceStatsConverterImpl_1 = require("../price-list/conversions/PriceStatsConverterImpl");

var ApprovalStatusConverter_1 = require("./conversions/ApprovalStatusConverter");

var ApprovalStatusConverterImpl_1 = require("./conversions/ApprovalStatusConverterImpl");

var CommonReleaseOverviewConverter_1 = require("./conversions/CommonReleaseOverviewConverter");

var CommonReleaseOverviewConverterImpl_1 = require("./conversions/CommonReleaseOverviewConverterImpl");

var ExportedReleaseConverter_1 = require("./conversions/ExportedReleaseConverter");

var ExportedReleaseConverterImpl_1 = require("./conversions/ExportedReleaseConverterImpl");

var ExportedUpdateRequestConverter_1 = require("./conversions/ExportedUpdateRequestConverter");

var ExportedUpdateRequestConverterImpl_1 = require("./conversions/ExportedUpdateRequestConverterImpl");

var FinalProductPriceConverter_1 = require("./conversions/FinalProductPriceConverter");

var FinalProductPriceConverterImpl_1 = require("./conversions/FinalProductPriceConverterImpl");

var ImpactRecordConverter_1 = require("./conversions/ImpactRecordConverter");

var ImpactRecordConverterImpl_1 = require("./conversions/ImpactRecordConverterImpl");

var ImpactRecordSumsConverter_1 = require("./conversions/ImpactRecordSumsConverter");

var ImpactRecordSumsConverterImpl_1 = require("./conversions/ImpactRecordSumsConverterImpl");

var OptimalPriceConverter_1 = require("./conversions/OptimalPriceConverter");

var OptimalPriceConverterImpl_1 = require("./conversions/OptimalPriceConverterImpl");

var PriceCodeUpdateRequestConverter_1 = require("./conversions/PriceCodeUpdateRequestConverter");

var PriceCodeUpdateRequestConverterImpl_1 = require("./conversions/PriceCodeUpdateRequestConverterImpl");

var PriceCommentConverter_1 = require("./conversions/PriceCommentConverter");

var PriceCommentConverterImpl_1 = require("./conversions/PriceCommentConverterImpl");

var PriceCommentSaveRequestConverter_1 = require("./conversions/PriceCommentSaveRequestConverter");

var PriceCommentSaveRequestConverterImpl_1 = require("./conversions/PriceCommentSaveRequestConverterImpl");

var PriceZoneReleasePricesConverter_1 = require("./conversions/PriceZoneReleasePricesConverter");

var PriceZoneReleasePricesConverterImpl_1 = require("./conversions/PriceZoneReleasePricesConverterImpl");

var PriceZoneStatsConverter_1 = require("./conversions/PriceZoneStatsConverter");

var PriceZoneStatsConverterImpl_1 = require("./conversions/PriceZoneStatsConverterImpl");

var ProductPricesUploadConverter_1 = require("./conversions/ProductPricesUploadConverter");

var ProductPricesUploadConverterImpl_1 = require("./conversions/ProductPricesUploadConverterImpl");

var ReleaseActionFeasibilityConverter_1 = require("./conversions/ReleaseActionFeasibilityConverter");

var ReleaseActionFeasibilityConverterImpl_1 = require("./conversions/ReleaseActionFeasibilityConverterImpl");

var ReleaseActionRequestConverter_1 = require("./conversions/ReleaseActionRequestConverter");

var ReleaseActionRequestConverterImpl_1 = require("./conversions/ReleaseActionRequestConverterImpl");

var ReleaseActionResultConverter_1 = require("./conversions/ReleaseActionResultConverter");

var ReleaseActionResultConverterImpl_1 = require("./conversions/ReleaseActionResultConverterImpl");

var ReleaseConverter_1 = require("./conversions/ReleaseConverter");

var ReleaseConverterImpl_1 = require("./conversions/ReleaseConverterImpl");

var ReleaseEditInfoConverter_1 = require("./conversions/ReleaseEditInfoConverter");

var ReleaseEditInfoConverterImpl_1 = require("./conversions/ReleaseEditInfoConverterImpl");

var ReleaseImpactDTOConverter_1 = require("./conversions/ReleaseImpactDTOConverter");

var ReleaseImpactDTOConverterImpl_1 = require("./conversions/ReleaseImpactDTOConverterImpl");

var ReleaseItemConverter_1 = require("./conversions/ReleaseItemConverter");

var ReleaseItemConverterImpl_1 = require("./conversions/ReleaseItemConverterImpl");

var ReleaseItemPromosConverter_1 = require("./conversions/ReleaseItemPromosConverter");

var ReleaseItemPromosConverterImpl_1 = require("./conversions/ReleaseItemPromosConverterImpl");

var ReleaseItemRepricingConverter_1 = require("./conversions/ReleaseItemRepricingConverter");

var ReleaseItemRepricingConverterImpl_1 = require("./conversions/ReleaseItemRepricingConverterImpl");

var ReleasePartActionResultConverter_1 = require("./conversions/ReleasePartActionResultConverter");

var ReleasePartActionResultConverterImpl_1 = require("./conversions/ReleasePartActionResultConverterImpl");

var ReleasePartConverter_1 = require("./conversions/ReleasePartConverter");

var ReleasePartConverterImpl_1 = require("./conversions/ReleasePartConverterImpl");

var ReleasePriceCalculationConverter_1 = require("./conversions/ReleasePriceCalculationConverter");

var ReleasePriceCalculationConverterImpl_1 = require("./conversions/ReleasePriceCalculationConverterImpl");

var ReleaseTotalDTOConverter_1 = require("./conversions/ReleaseTotalDTOConverter");

var ReleaseTotalDTOConverterImpl_1 = require("./conversions/ReleaseTotalDTOConverterImpl");

var RoleApprovalStatusConverter_1 = require("./conversions/RoleApprovalStatusConverter");

var RoleApprovalStatusConverterImpl_1 = require("./conversions/RoleApprovalStatusConverterImpl");

var RepriceableItemReleaseProjectionDTOConverter_1 = require("./conversions/sellout/RepriceableItemReleaseProjectionDTOConverter");

var RepriceableItemReleaseProjectionDTOConverterImpl_1 = require("./conversions/sellout/RepriceableItemReleaseProjectionDTOConverterImpl");

var SelloutImpactRecordConverter_1 = require("./conversions/sellout/SelloutImpactRecordConverter");

var SelloutImpactRecordConverterImpl_1 = require("./conversions/sellout/SelloutImpactRecordConverterImpl");

var SelloutImpactRecordSumsConverter_1 = require("./conversions/sellout/SelloutImpactRecordSumsConverter");

var SelloutImpactRecordSumsConverterImpl_1 = require("./conversions/sellout/SelloutImpactRecordSumsConverterImpl");

var SelloutItemFilterConverter_1 = require("./conversions/sellout/SelloutItemFilterConverter");

var SelloutItemFilterConverterImpl_1 = require("./conversions/sellout/SelloutItemFilterConverterImpl");

var SelloutProductPriceImpactConverter_1 = require("./conversions/sellout/SelloutProductPriceImpactConverter");

var SelloutProductPriceImpactConverterImpl_1 = require("./conversions/sellout/SelloutProductPriceImpactConverterImpl");

var SelloutReleaseCategoryPreviewConverter_1 = require("./conversions/sellout/SelloutReleaseCategoryPreviewConverter");

var SelloutReleaseCategoryPreviewConverterImpl_1 = require("./conversions/sellout/SelloutReleaseCategoryPreviewConverterImpl");

var SelloutReleaseCategoryTotalDTOConverter_1 = require("./conversions/sellout/SelloutReleaseCategoryTotalDTOConverter");

var SelloutReleaseCategoryTotalDTOConverterImpl_1 = require("./conversions/sellout/SelloutReleaseCategoryTotalDTOConverterImpl");

var SelloutReleaseConverter_1 = require("./conversions/sellout/SelloutReleaseConverter");

var SelloutReleaseConverterImpl_1 = require("./conversions/sellout/SelloutReleaseConverterImpl");

var SelloutReleaseItemConverter_1 = require("./conversions/sellout/SelloutReleaseItemConverter");

var SelloutReleaseItemConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemConverterImpl");

var SelloutReleaseItemEvaluationConverter_1 = require("./conversions/sellout/SelloutReleaseItemEvaluationConverter");

var SelloutReleaseItemEvaluationConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemEvaluationConverterImpl");

var SelloutReleaseItemKeyConverter_1 = require("./conversions/sellout/SelloutReleaseItemKeyConverter");

var SelloutReleaseItemKeyConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemKeyConverterImpl");

var SelloutReleaseItemPricesConverter_1 = require("./conversions/sellout/SelloutReleaseItemPricesConverter");

var SelloutReleaseItemPricesConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemPricesConverterImpl");

var SelloutReleaseItemSnapshotConverter_1 = require("./conversions/sellout/SelloutReleaseItemSnapshotConverter");

var SelloutReleaseItemSnapshotConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemSnapshotConverterImpl");

var SelloutReleaseItemSupplyDataConverter_1 = require("./conversions/sellout/SelloutReleaseItemSupplyDataConverter");

var SelloutReleaseItemSupplyDataConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemSupplyDataConverterImpl");

var SelloutReleaseItemUpdateConverter_1 = require("./conversions/sellout/SelloutReleaseItemUpdateConverter");

var SelloutReleaseItemUpdateConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemUpdateConverterImpl");

var SelloutReleaseItemUpdateRequestConverter_1 = require("./conversions/sellout/SelloutReleaseItemUpdateRequestConverter");

var SelloutReleaseItemUpdateRequestConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemUpdateRequestConverterImpl");

var SelloutReleaseItemWithPartConverter_1 = require("./conversions/sellout/SelloutReleaseItemWithPartConverter");

var SelloutReleaseItemWithPartConverterImpl_1 = require("./conversions/sellout/SelloutReleaseItemWithPartConverterImpl");

var SelloutReleasePartConverter_1 = require("./conversions/sellout/SelloutReleasePartConverter");

var SelloutReleasePartConverterImpl_1 = require("./conversions/sellout/SelloutReleasePartConverterImpl");

var SelloutReleasePreviousOpenOverviewConverter_1 = require("./conversions/sellout/SelloutReleasePreviousOpenOverviewConverter");

var SelloutReleasePreviousOpenOverviewConverterImpl_1 = require("./conversions/sellout/SelloutReleasePreviousOpenOverviewConverterImpl");

var SelloutReleaseSnapshotConverter_1 = require("./conversions/sellout/SelloutReleaseSnapshotConverter");

var SelloutReleaseSnapshotConverterImpl_1 = require("./conversions/sellout/SelloutReleaseSnapshotConverterImpl");

var SelloutReleaseTotalDTOConverter_1 = require("./conversions/sellout/SelloutReleaseTotalDTOConverter");

var SelloutReleaseTotalDTOConverterImpl_1 = require("./conversions/sellout/SelloutReleaseTotalDTOConverterImpl");

var SelloutSourceImpactValuesConverter_1 = require("./conversions/sellout/SelloutSourceImpactValuesConverter");

var SelloutSourceImpactValuesConverterImpl_1 = require("./conversions/sellout/SelloutSourceImpactValuesConverterImpl");

var SelloutTargetConverter_1 = require("./conversions/sellout/SelloutTargetConverter");

var SelloutTargetConverterImpl_1 = require("./conversions/sellout/SelloutTargetConverterImpl");

var SelloutReleaseItemSupplyConverter_1 = require("./conversions/SelloutReleaseItemSupplyConverter");

var SelloutReleaseItemSupplyConverterImpl_1 = require("./conversions/SelloutReleaseItemSupplyConverterImpl");
/**
 * Release app module.
 * @author Radek Beran
 */


var ReleaseAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ReleaseAppModule, _AppModule_1$AppModul);

  function ReleaseAppModule() {
    var _this;

    _classCallCheck(this, ReleaseAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = ReleaseAppModule.NAME;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PriceStatsConverter_1.PriceStatsConverter).to(PriceStatsConverterImpl_1.PriceStatsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceZoneStatsConverter_1.PriceZoneStatsConverter).to(PriceZoneStatsConverterImpl_1.PriceZoneStatsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseItemPromosConverter_1.ReleaseItemPromosConverter).to(ReleaseItemPromosConverterImpl_1.ReleaseItemPromosConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseEditInfoConverter_1.ReleaseEditInfoConverter).to(ReleaseEditInfoConverterImpl_1.ReleaseEditInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ProductPricesUploadConverter_1.ProductPricesUploadConverter).to(ProductPricesUploadConverterImpl_1.ProductPricesUploadConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ImpactRecordSumsConverter_1.ImpactRecordSumsConverter).to(ImpactRecordSumsConverterImpl_1.ImpactRecordSumsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ImpactRecordConverter_1.ImpactRecordConverter).to(ImpactRecordConverterImpl_1.ImpactRecordConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(FinalProductPriceConverter_1.FinalProductPriceConverter).to(FinalProductPriceConverterImpl_1.FinalProductPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(OptimalPriceConverter_1.OptimalPriceConverter).to(OptimalPriceConverterImpl_1.OptimalPriceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceCodeUpdateRequestConverter_1.PriceCodeUpdateRequestConverter).to(PriceCodeUpdateRequestConverterImpl_1.PriceCodeUpdateRequestConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedUpdateRequestConverter_1.ExportedUpdateRequestConverter).to(ExportedUpdateRequestConverterImpl_1.ExportedUpdateRequestConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RoleApprovalStatusConverter_1.RoleApprovalStatusConverter).to(RoleApprovalStatusConverterImpl_1.RoleApprovalStatusConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ApprovalStatusConverter_1.ApprovalStatusConverter).to(ApprovalStatusConverterImpl_1.ApprovalStatusConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseActionFeasibilityConverter_1.ReleaseActionFeasibilityConverter).to(ReleaseActionFeasibilityConverterImpl_1.ReleaseActionFeasibilityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleasePartConverter_1.ReleasePartConverter).to(ReleasePartConverterImpl_1.ReleasePartConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceZoneReleasePricesConverter_1.PriceZoneReleasePricesConverter).to(PriceZoneReleasePricesConverterImpl_1.PriceZoneReleasePricesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceCommentConverter_1.PriceCommentConverter).to(PriceCommentConverterImpl_1.PriceCommentConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PriceCommentSaveRequestConverter_1.PriceCommentSaveRequestConverter).to(PriceCommentSaveRequestConverterImpl_1.PriceCommentSaveRequestConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseActionRequestConverter_1.ReleaseActionRequestConverter).to(ReleaseActionRequestConverterImpl_1.ReleaseActionRequestConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseActionResultConverter_1.ReleaseActionResultConverter).to(ReleaseActionResultConverterImpl_1.ReleaseActionResultConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseItemConverter_1.ReleaseItemConverter).to(ReleaseItemConverterImpl_1.ReleaseItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseTotalDTOConverter_1.ReleaseTotalDTOConverter).to(ReleaseTotalDTOConverterImpl_1.ReleaseTotalDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseTotalDTOConverter_1.SelloutReleaseTotalDTOConverter).to(SelloutReleaseTotalDTOConverterImpl_1.SelloutReleaseTotalDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleasePartActionResultConverter_1.ReleasePartActionResultConverter).to(ReleasePartActionResultConverterImpl_1.ReleasePartActionResultConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseItemRepricingConverter_1.ReleaseItemRepricingConverter).to(ReleaseItemRepricingConverterImpl_1.ReleaseItemRepricingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseConverter_1.ReleaseConverter).to(ReleaseConverterImpl_1.ReleaseConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemKeyConverter_1.SelloutReleaseItemKeyConverter).to(SelloutReleaseItemKeyConverterImpl_1.SelloutReleaseItemKeyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemUpdateConverter_1.SelloutReleaseItemUpdateConverter).to(SelloutReleaseItemUpdateConverterImpl_1.SelloutReleaseItemUpdateConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemUpdateRequestConverter_1.SelloutReleaseItemUpdateRequestConverter).to(SelloutReleaseItemUpdateRequestConverterImpl_1.SelloutReleaseItemUpdateRequestConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseConverter_1.SelloutReleaseConverter).to(SelloutReleaseConverterImpl_1.SelloutReleaseConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseSnapshotConverter_1.SelloutReleaseSnapshotConverter).to(SelloutReleaseSnapshotConverterImpl_1.SelloutReleaseSnapshotConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemPricesConverter_1.SelloutReleaseItemPricesConverter).to(SelloutReleaseItemPricesConverterImpl_1.SelloutReleaseItemPricesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemSupplyDataConverter_1.SelloutReleaseItemSupplyDataConverter).to(SelloutReleaseItemSupplyDataConverterImpl_1.SelloutReleaseItemSupplyDataConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemConverter_1.SelloutReleaseItemConverter).to(SelloutReleaseItemConverterImpl_1.SelloutReleaseItemConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemSnapshotConverter_1.SelloutReleaseItemSnapshotConverter).to(SelloutReleaseItemSnapshotConverterImpl_1.SelloutReleaseItemSnapshotConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutTargetConverter_1.SelloutTargetConverter).to(SelloutTargetConverterImpl_1.SelloutTargetConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedReleaseConverter_1.ExportedReleaseConverter).to(ExportedReleaseConverterImpl_1.ExportedReleaseConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleasePriceCalculationConverter_1.ReleasePriceCalculationConverter).to(ReleasePriceCalculationConverterImpl_1.ReleasePriceCalculationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleasePartConverter_1.SelloutReleasePartConverter).to(SelloutReleasePartConverterImpl_1.SelloutReleasePartConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemWithPartConverter_1.SelloutReleaseItemWithPartConverter).to(SelloutReleaseItemWithPartConverterImpl_1.SelloutReleaseItemWithPartConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseCategoryPreviewConverter_1.SelloutReleaseCategoryPreviewConverter).to(SelloutReleaseCategoryPreviewConverterImpl_1.SelloutReleaseCategoryPreviewConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutItemFilterConverter_1.SelloutItemFilterConverter).to(SelloutItemFilterConverterImpl_1.SelloutItemFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutImpactRecordConverter_1.SelloutImpactRecordConverter).to(SelloutImpactRecordConverterImpl_1.SelloutImpactRecordConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutImpactRecordSumsConverter_1.SelloutImpactRecordSumsConverter).to(SelloutImpactRecordSumsConverterImpl_1.SelloutImpactRecordSumsConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseCategoryTotalDTOConverter_1.SelloutReleaseCategoryTotalDTOConverter).to(SelloutReleaseCategoryTotalDTOConverterImpl_1.SelloutReleaseCategoryTotalDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RepriceableItemReleaseProjectionDTOConverter_1.RepriceableItemReleaseProjectionDTOConverter).to(RepriceableItemReleaseProjectionDTOConverterImpl_1.RepriceableItemReleaseProjectionDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ReleaseImpactDTOConverter_1.ReleaseImpactDTOConverter).to(ReleaseImpactDTOConverterImpl_1.ReleaseImpactDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemEvaluationConverter_1.SelloutReleaseItemEvaluationConverter).to(SelloutReleaseItemEvaluationConverterImpl_1.SelloutReleaseItemEvaluationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(RealImpactValueConverter_1.RealImpactValueConverter).to(RealImpactValueConverterImpl_1.RealImpactValueConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutProductPriceImpactConverter_1.SelloutProductPriceImpactConverter).to(SelloutProductPriceImpactConverterImpl_1.SelloutProductPriceImpactConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleasePreviousOpenOverviewConverter_1.SelloutReleasePreviousOpenOverviewConverter).to(SelloutReleasePreviousOpenOverviewConverterImpl_1.SelloutReleasePreviousOpenOverviewConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(CommonReleaseOverviewConverter_1.CommonReleaseOverviewConverter).to(CommonReleaseOverviewConverterImpl_1.CommonReleaseOverviewConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutSourceImpactValuesConverter_1.SelloutSourceImpactValuesConverter).to(SelloutSourceImpactValuesConverterImpl_1.SelloutSourceImpactValuesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(SelloutReleaseItemSupplyConverter_1.SelloutReleaseItemSupplyConverter).to(SelloutReleaseItemSupplyConverterImpl_1.SelloutReleaseItemSupplyConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ReleaseAppModule;
}(AppModule_1.AppModule);

exports.ReleaseAppModule = ReleaseAppModule;
ReleaseAppModule.NAME = 'release';